class PickupAvailability extends HTMLElement {
  connectedCallback() {
    this.productUrl = this.getAttribute('data-product-url');
    this.sectionId = this.getAttribute('data-section-id');
    this.drawer = this.querySelector('x-drawer');

    if (!this.drawer || !this.productUrl || !this.sectionId) return;

    this.fetched = false;
    this.onDrawerShow = this.onDrawerShow.bind(this);
    this.drawer.addEventListener('dialog:after-show', this.onDrawerShow);
  }

  disconnectedCallback() {
    if (this.drawer) {
      this.drawer.removeEventListener('dialog:after-show', this.onDrawerShow);
    }
  }

  async onDrawerShow() {
    if (this.fetched) return;
    this.fetched = true;

    const rows = this.drawer.querySelectorAll('[data-pickup-variant-row]');
    const variantIds = Array.from(
      new Set(Array.from(rows).map((r) => r.getAttribute('data-variant-id')))
    );

    await Promise.all(variantIds.map((id) => this.fetchVariant(id)));
  }

  async fetchVariant(variantId) {
    const sep = this.productUrl.includes('?') ? '&' : '?';
    const url = `${this.productUrl}${sep}variant=${variantId}&section_id=${this.sectionId}`;

    let availabilityByLocation = new Map();
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      doc.querySelectorAll('[data-pickup-location-row]').forEach((row) => {
        const locationId = row.getAttribute('data-location-id');
        const available = row.getAttribute('data-available') === 'true';
        if (locationId) availabilityByLocation.set(locationId, available);
      });
    } catch (err) {
      console.warn('[pickup-availability] fetch failed for variant', variantId, err);
    }

    this.drawer.querySelectorAll(
      `[data-pickup-variant-row][data-variant-id="${variantId}"]`
    ).forEach((row) => {
      const locationId = row
        .closest('[data-pickup-location]')
        ?.getAttribute('data-pickup-location');
      const available = locationId ? availabilityByLocation.get(locationId) : undefined;
      this.updateRow(row, available);
    });
  }

  updateRow(row, available) {
    row.removeAttribute('aria-busy');
    row.setAttribute('data-available', available === true ? 'true' : 'false');
  }
}

if (!window.customElements.get('pickup-availability')) {
  window.customElements.define('pickup-availability', PickupAvailability);
}
